import farolLogo from "@/assets/farol-10.png"
import { cn } from "@/lib/utils"

export function BrandMark({ compact = false, showSymbol = true, showSymbolImage = true, symbolImageSrc = farolLogo, symbolImageAlt = "Farol", label = "Farol", className, labelClassName, symbolClassName }: { compact?: boolean; showSymbol?: boolean; showSymbolImage?: boolean; symbolImageSrc?: string; symbolImageAlt?: string; label?: string; className?: string; labelClassName?: string; symbolClassName?: string }) {
  return (
    <div className={cn("flex items-center gap-3", className)}>
      {showSymbol ? (
        <div data-slot="brand-symbol" className={cn("size-8 shrink-0 overflow-hidden rounded-md bg-primary", symbolClassName)}>
          {showSymbolImage ? <img src={symbolImageSrc} alt={symbolImageAlt} className="size-full object-cover" /> : null}
        </div>
      ) : null}
      {!compact ? (
        <p className={cn("text-sm font-semibold leading-none", labelClassName)}>{label}</p>
      ) : null}
    </div>
  )
}
